module.exports = __webpack_public_path__ + "static/AxionLabelArt-7b03462f4b9ff9dd40759c006f99d86f.jpg";